<div (mouseover)="onMouseOver()" (mouseout)="onMouseOut()">
	<ui-notify
		[text]="text()"
		[type]="type()"
		[closable]="closable()"
		(closeNotify)="closeNotify.emit()"
	>
		@if (timer() && currentProgress()) {
			<div
				class="absolute left-0 bottom-0 h-px bg-secondary-600 transition-all duration-300"
				[style.width.%]="currentProgress()"
			></div>
		}
	</ui-notify>
</div>
